import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { Checkbox } from '@wartek-id/checkbox-v1'
import { Icon } from '@wartek-id/icon-v2'
import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import { PELAKSANAAN_PRAKTIK_KINERJA_STATE_TITLE } from 'app/KinerjaPSPegawaiPage/constants/praktikKinerja'

type TDialogPelaksanaanAppealRejectProps = {
  isOpen: boolean
  isLoading: boolean
  editState: string
  name: string
  onClose: () => void
  onConfirm: () => void
}
export const DialogPelaksanaanAppealReject: React.FC<
  TDialogPelaksanaanAppealRejectProps
> = ({ isOpen, isLoading, editState, name, onConfirm, onClose }) => {
  const [agree, setAgree] = React.useState<boolean>(false)
  const editStateTitle = React.useMemo(
    () =>
      PELAKSANAAN_PRAKTIK_KINERJA_STATE_TITLE?.[
        (editState ?? '').toLowerCase()
      ] ?? editState,
    [editState]
  )

  React.useEffect(() => {
    return () => {
      setAgree(false)
    }
  }, [isOpen])

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      autoFocus={false}
      returnFocus={false}
    >
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <Icon fontSize="lg" color="critical">
            cancel
          </Icon>

          <div className="space-y-1">
            <Text variant="heading-md">
              Tolak pengajuan perubahan isi {editStateTitle} milik {name}?
            </Text>
            <Text color="subdued" variant="body">
              Status penolakan akan ditampilkan ke Pengawas dan Pengawas dapat
              mengajukan perubahan lagi.
            </Text>
          </div>

          <div className="pb-4">
            <Checkbox
              className="mt-2"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
            >
              <Text variant="heading-sm">
                Saya mengerti bahwa Pengawas dapat mengajukan perubahan lagi
              </Text>
            </Checkbox>
          </div>

          <div className="flex justify-end space-x-5">
            <Button
              data-testid="appeal-rollback-back-button"
              disabled={isLoading}
              onClick={onClose}
              color="white"
              size="lg"
            >
              Kembali
            </Button>
            <Button
              onClick={onConfirm}
              className="space-x-1"
              color="blue"
              size="lg"
              disabled={!agree || isLoading}
              isLoading={isLoading}
            >
              <span>Lanjut tolak</span>
            </Button>
          </div>
        </div>
        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}
